import { useCallback } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@b2bportal/core-types";
import type { AvailabilityApiCall } from "../store/thunks/api/fetchAvailability";
import { fetchHotels } from "../store/thunks/fetchHotels";

export const useFetchHotels = () => {
  const dispatch = useDispatch<AppDispatch>();

  return useCallback(
    (req: AvailabilityApiCall) => {
      dispatch(fetchHotels(req));
    },
    [dispatch]
  );
};
